/**
 * The slug for the generate entity secret ciphertext operation.
 */
export const GENERATE_ENTITY_SECRET_CIPHER_TEXT =
  '/custom/generate-entity-secret-ciphertext'
